import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from "./components/login/login.component";
import {AuditlogComponent} from "./components/auditlog/auditlog.component";
import {UsersComponent} from "./components/users/users.component";
import {PermissionComponent} from "./components/permission/permission.component";
import {FirmwareComponent} from "./components/firmware/firmware.component";
import {DeviceEventsComponent} from "./components/device-events/device-events.component";
import {CarsComponent} from "./components/cars/cars.component";
import {CompanyComponent} from "./components/company/company.component";
import {DashboardComponent} from "./components/dashboard/dashboard.component";
import {AuthGuard} from "./utilities/auth.guard";
import {Role} from "./dip/role";
import {OrganizationsComponent} from "./components/organizations/organizations.component";
import {ResetPasswordComponent} from "./components/login/reset-password/reset-password.component";
import {CommunicationLogComponent} from "./components/communication-log/communication-log.component";
import {DistributorComponent} from "./components/distributor/distributor.component";

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'reloadPage',
    children: []
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'resetPassword',
    component: ResetPasswordComponent
  },
  {
    path: 'company',
    component: CompanyComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'distributor',
    component: DistributorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'vehicles',
    component: CarsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'firmwares',
    component: FirmwareComponent,
    canActivate: [AuthGuard],
    data: {
      role: Role.ROLE_SYS
    }
  },
  {
    path: 'deviceEvents',
    component: DeviceEventsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'permissions',
    component: PermissionComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'auditLogs',
    component: AuditlogComponent,
    canActivate: [AuthGuard],
    data: {
      role: Role.ROLE_SYS
    }
  },
  {
    path: 'users',
    component: UsersComponent,
    canActivate: [AuthGuard],
    data: {
      role: Role.ROLE_USER_EDIT
    }
  },
  {
    path: 'organizations',
    component: OrganizationsComponent,
    canActivate: [AuthGuard],
    data: {
      role: Role.ROLE_SYS
    }
  },
  {
    path: 'communicationLogs',
    component: CommunicationLogComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
